import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "../services/axiosInstance";
import Loader from "../components/Loader";

export default function ResetPassword(){

  const [password,setPassword] = useState("");
  const [confirmPassword,setConfirmPassword] = useState("");
  const [error,setError] = useState("");
  const [loading,setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email;

  const resetPassword = async () => {

    if(password !== confirmPassword){
      setError("Passwords do not match");
      return;
    }

    try{

      setLoading(true);
      setError("");
      await axiosInstance.post("/password/resetpassword", {
       email:email,
        password:password
      });
    
      alert("Password updated successfully,Please try");
      navigate("/login");

    }catch(err){
      alert("Failed to update password");
    }
    finally{
      setLoading(false);
    }

  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
         {loading && <Loader />}
      <div className="bg-white shadow-xl rounded-2xl p-8 w-full max-w-md">

        <h2 className="text-2xl font-bold text-center mb-4">
          Reset Password
        </h2>

        <p className="text-gray-600 text-sm text-center mb-6">
          Enter your new password
        </p>

        {error && (
          <div className="bg-red-100 text-red-600 text-sm p-2 rounded mb-4">
            {error}
          </div>
        )}

        <input
          type="password"
          placeholder="New Password"
          className="w-full px-4 py-2 border rounded-lg mb-4"
          onChange={(e)=>setPassword(e.target.value)}
        />

        <input
          type="password"
          placeholder="Confirm Password"
          className="w-full px-4 py-2 border rounded-lg mb-4"
          onChange={(e)=>setConfirmPassword(e.target.value)}
        />

        <button
          onClick={resetPassword}
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
        >
          {loading ? "Updating..." : "Update Password"}
        </button>

      </div>

    </div>
  );
}